export * from './FileTypeMarkupIcon';
export * from './FileTypeMarkupIcon16Light';
export * from './FileTypeMarkupIcon16Regular';
export * from './FileTypeMarkupIcon16Solid';
export * from './FileTypeMarkupIcon20Light';
export * from './FileTypeMarkupIcon20Regular';
export * from './FileTypeMarkupIcon20Solid';
export * from './FileTypeMarkupIcon24Regular';
export * from './FileTypeMarkupIcon24Solid';
export * from './FileTypeMarkupIcon32Regular';
export * from './FileTypeMarkupIcon64Regular';
